import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface TypeCapteur {
  id: number;
  nom: string;
}

@Injectable({ providedIn: 'root' })
export class TypeCapteursService {
  private readonly baseUrl = `${environment.apiBaseUrl}/api/type_capteurs`;

  constructor(private http: HttpClient) {}

  list(): Observable<TypeCapteur[]> {
    return this.http.get<TypeCapteur[]>(this.baseUrl);
  }
}
